<template>
  <form class="product-favourites" @submit.prevent="saveFavourites">
    <div class="grid grid-row">
      <div class="mx-3 my-2">
        <h1 class="text-xl font-bold">{{ computedHeading }}</h1>
      </div>
    </div>
    <div v-if="showNewFavourite !== null">
      <div v-if="showNewFavourite" class="row grid-margin">
        <div class="col-md-12">
          <p class="text-pdsPrimaryColor mb-2 text-base">Favorietenlijst naam</p>
          <v-input-group-simple-2
            class=""
            placeholder="Nieuwe favorietenlijst"
            id="favouriteName"
            v-model="newBundleName"
            type="text"
            @input="computeBundleName($event.target.value)"
            :rules="{
              required: showNewFavourite ? true : false
            }"
          />
        </div>
      </div>
      <div v-else class="grid grid-rows ml-3">
        <div class="">
          <combo-boxes
            disabledInput
            v-model="selectedFavouriteId"
            :list="computedFavoriteCategories"
            id="favoriteCategories"
            name="favoriteCategories"
            label="Selecteer hier je favorieten lijst"
          ></combo-boxes>
        </div>
        <div class="self-center ml-2 mb-1 justify-items-end">
          <button
            @click="toggleShowNewFavourite"
            class="flex justify-center py-2 px-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full text-nowrap"
          >
            <v-plus-circle-icon />
            <span class="ml-2">Maak nieuwe lijst</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row grid-margin">
      <div class="col-md-12">
        <table>
          <colgroup>
            <col v-for="n in 1" :key="n" :class="'table-col-' + n++" />
          </colgroup>
          <thead>
            <tr>
              <th>Artikel</th>
              <th>Aantal</th>
              <th>Beschrijving</th>
              <th>Verpakking</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="product-favourites__imgWrapper">
                  <img :src="getImageUrl(computedProductImageUrl)" @error="handleImageError" />
                </div>
              </td>

              <td class="product-favourites__count">
                <div class="product-favourites__count__quantity">
                  <v-minus class="product-favourites__count__icon" @click.prevent="reduceQuantity()" />
                  <input
                    v-model="productQuantity"
                    type="number"
                    min="1"
                    max="999"
                    maxlength="3"
                    autocomplete="off"
                    class="focus:outline-none"
                  />
                  <v-plus
                    class="product-favourites__count__icon product-favourites__count__plus"
                    @click.prevent="increaseQuantity()"
                  />
                </div>
              </td>
              <td>{{ $toTitleCase(product.title) }}</td>
              <td>{{ product.packagingUnit }} {{ product.packagingLabel }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row grid-padding grid-justify-content-end">
      <a class="text-pdsPrimaryColor font-bold mt-2 cursor-pointer text-xs md:text-base mx-3" @click="closeOverlay">
        Annuleren
      </a>
      <button
        type="submit"
        class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-cta rounded-full text-nowrap"
        :disabled="showNewFavourite === null"
      >
        Opslaan
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';
import VPlus from 'icons/Plus';
import VMinus from 'icons/Minus';
import VPlusCircleIcon from 'icons/PlusCircle';
import { useStore } from 'vuex';
import router from '@/router';
import { $validateAllComponents } from '@/validate/index.js';
import { useForm } from 'vee-validate';

export default {
  name: 'VProductFavourites',
  components: {
    VPlus,
    VMinus,
    VPlusCircleIcon
  },
  props: {
    product: Object,
    baseProduct: Object
  },
  setup() {
    const store = useStore();
    const fetchFavourites = (value) => store.dispatch('catalog/fetchFavourites', value);

    return {
      fetchFavourites
    };
  },
  data() {
    const { validate } = useForm();

    return {
      validate,
      favoriteCategories: [],
      newBundleName: null,
      productQuantity: 1,
      showNewFavourite: null,
      validationStatus: false,
      selectedFavouriteId: null
    };
  },
  computed: {
    computedProductImageUrl() {
      return this.product.imageUrl
        ? this.product.imageUrl
        : this.baseProduct.thumbnailImageUrl
        ? this.baseProduct.thumbnailImageUrl
        : '';
    },
    computedHeading() {
      return this.showNewFavourite ? 'Maak nieuwe lijst' : 'Toevoegen aan favorietenlijst';
    },
    computedFavoriteCategories() {
      let result = [];
      this.favoriteCategories.forEach((favourite) => {
        result.push({
          id: favourite.bundleId,
          data: favourite.name
        });
      });
      return result;
    },
    isReplenishmentFlow() {
      return router.currentRoute.value.meta.flow === 'replenishment';
    }
  },
  mounted() {
    let favoritesParams = {
      filterBy: null,
      bundleType: this.isReplenishmentFlow
    };
    axios.post('Catalogue/GetFavourites', favoritesParams).then((response) => {
      if (response && response.data) {
        this.favoriteCategories = response.data;
        if (this.favoriteCategories.length > 0) {
          this.showNewFavourite = false;
          this.updateSelectedFavourite({
            id: this.favoriteCategories[0].bundleId,
            data: this.favoriteCategories[0].name
          });
        } else {
          this.showNewFavourite = true;
        }
      }
    });
  },
  methods: {
    computeValidationStatus() {
      const selectedCategories = this.favoriteCategories.filter((f) => f.isFavorite === true);
      if (
        (!this.newBundleName && selectedCategories.length === 0) ||
        (this.showNewFavourite && !this.newBundleName) ||
        (!this.showNewFavourite && selectedCategories.length === 0)
      ) {
        this.validationStatus = true;
      } else {
        this.validationStatus = false;
      }
      return this.validationStatus;
    },
    saveFavourites(e) {
      e.stopPropagation();
      $validateAllComponents(this).then((validated) => {
        if (validated) {
          if (this.computeValidationStatus()) {
            return;
          }
          if (this.showNewFavourite) {
            axios
              .post('FavouriteProduct/CreateFavouriteListWithProducts', {
                name: this.newBundleName,
                bundleType: this.isReplenishmentFlow,
                favouriteProducts: [
                  {
                    productId: this.product.productId,
                    quantity: this.productQuantity
                  }
                ]
              })
              .then((response) => {
                if (response && response.data) {
                  this.resetFavourites();
                }
              });
          } else {
            axios
              .post('FavouriteProduct/AddProductToFavouriteList', {
                bundleId: this.selectedFavouriteId?.id || null,
                productId: this.product.productId,
                quantity: this.productQuantity
              })
              .then((response) => {
                if (response && response.data) {
                  this.resetFavourites();
                }
              });
          }
        }
      });
    },
    resetFavourites() {
      const selectedCategories = this.favoriteCategories.filter((f) => f.isFavorite === true);
      const isAdded = selectedCategories.length > 0 || (this.newBundleName && this.newBundleName.length > 0);
      let favouritesParams = {
        bundleType: this.isReplenishmentFlow
      };
      this.fetchFavourites(favouritesParams);
      this.$emit('success', isAdded);
    },
    /**
     * @function reduceQuantity
     */
    reduceQuantity() {
      if (this.productQuantity === 1) {
        return;
      }
      this.productQuantity -= 1;
    },
    /**
     * @function increaseQuantity
     */
    increaseQuantity() {
      if (this.productQuantity === 999) {
        return;
      }
      this.productQuantity += 1;
    },
    computeBundleName(value) {
      this.newBundleName = value;
      this.computeValidationStatus();
    },
    closeOverlay() {
      this.$emit('cancel');
    },
    updateSelectedFavourite(value) {
      this.favoriteCategories.forEach((favourite) => {
        if (favourite.bundleId === value.id) {
          favourite.isFavorite = true;
          this.selectedFavouriteId = this.computedFavoriteCategories.find((category) => category.id === value.id);
        } else {
          favourite.isFavorite = false;
        }
      });
    },
    toggleShowNewFavourite() {
      this.showNewFavourite = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.product-favourites {
  color: $teal-darkest;
  table {
    border-collapse: collapse;
    thead {
      td,
      th {
        padding: $table-row-license-cell-padding;
        border-bottom: 1px solid $grayish-very-dark;
      }
    }
    tbody {
      td {
        padding: $table-row-license-cell-padding;
      }
    }
  }
  h2 {
    margin: 0 !important;
    padding: 0 !important;
  }
  &__imgWrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-right: 8px;
    text-align: left;
    img {
      max-height: 80px;
      max-width: 80px;
      margin: auto;
      -ms-interpolation-mode: bicubic;
    }
  }
  &__count {
    &__quantity {
      border: 1px solid $gray;
      height: 31px;
      border-radius: 3px;
      width: 90px;
    }
    width: 120px;
    padding: 20px 20px 20px 0px;
    &__icon {
      fill: $teal-darkest;
      float: left;
      padding-top: 2px;
      cursor: pointer;
    }
    &__plus {
      text-align: right;
    }
    input {
      max-width: 35px;
      border-right: 1px solid $gray;
      border-left: 1px solid $gray;
      border-top: none;
      border-bottom: none;
      text-align: center;
      height: 29px;
      float: left;
    }
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    /* Firefox */
    input[type='number'] {
      -moz-appearance: textfield;
      appearance: textfield;
    }
  }
}
</style>
